function range(length, start) {
    return Array.from(new Array(length), (val, index) => index + start);
}

const categories = [
    { id: 'brain', range: ['00', '10'] },
    { id: 'knowledge', range: ['11', '33'] },
    { id: 'mind', range: ['34', '51'] },
    { id: 'body', range: ['52', '66'] },
    { id: 'soul', range: ['67', '78'] },
    { id: 'career', range: ['79', '89'] },
    { id: 'leisure', range: ['90', '99'] }
];

categories.forEach(category => {
    const [start, end] = category.range.map(r => parseInt(r, 10));
    category.lifeskillIds = range(end - start + 1, start).map(num => `${num < 10 ? '0' : ''}${num}`);
});

export default categories;

const startIndexes = categories.map(c => parseInt(c.range[0], 10));

export function getCategoryIdFromLifeskillId(lifeskillId) {
    let lifeskillIndex = parseInt(lifeskillId, 10);
    for (let i = startIndexes.length; i--; ) {
        if (lifeskillIndex >= startIndexes[i]) {
            return categories[i].id;
        }
    }
}

export function getLifeskillRangeFromCategoryId(categoryId) {
    return (categories.find(c => c.id === categoryId) || { range: ['??', '??'] }).range;
}
